import React, { useEffect, useState } from 'react';
import { Container, Paper, Tab, Tabs, Grid } from '@material-ui/core';
import { Switch, Link, useHistory } from 'react-router-dom';
import useAsiteRelaticsRoutes from '../hooks/useAsiteRelaticsRoutes';
import useStyles from '../../../styles/useStyles';
import useStylesPaper from '../../../styles/paper.styles';
import { useSettings } from '../hooks/useSettings';
import { ESyncLogsTabs } from '../types';
import AsiteSyncLogs from './AsiteSyncLogs/AsiteSyncLogs';
import RelaticsSyncLogs from './RelaticsSyncLogs/RelaticsSyncLogs';
import ConfigurationFolder from './ConfigurationFolders/ConfigurationFolders';
import useSecurity from './../hooks/useSecurity/useSecurity'
import { LoadingPanel } from '../../../ui';
import { useSignalr } from '../hooks/useSignalr';
import { SabsPrivateRoute } from '../../../components/PrivateRoute';
const Menu = () => {
    const classes = useStyles();
    const history = useHistory();
    const classesPaper = useStylesPaper();
    const { routes, path } = useAsiteRelaticsRoutes();
    const { changeTab, currentTab } = useSettings();
    const [tabsValue, setTabsValue] = useState('relatics');
    const { isPageAuthorized, isLoaded } = useSecurity();
    const accessDeniedPath = '/access-denied';

    const {connection} = useSignalr('/asite-relatics-sync-events');

    useEffect(() => {
        if(isLoaded) {
            if (!currentTab) {
                history.push(path + '/relatics');
            }
            else {
                setTabsValue(currentTab);
            }
        }

    }, [currentTab, setTabsValue, isLoaded]);



    return (
        <Container maxWidth="xl">
             {isLoaded && <Grid container spacing={3} justify="center">
                
               <Grid item md={12}>
                    <Paper className={classesPaper.root} style={{ height: '56px' }}>
                        <Tabs
                            className={classes.tab}
                            value={tabsValue}
                            indicatorColor="primary"
                            textColor="primary"
                            centered>
                            <Tab
                                className={classes.tabItem}
                                label="Relatics sync logs"
                                value={'relatics'}
                                component={Link}
                                to={routes['relatics']}
                                onClick={() => changeTab(ESyncLogsTabs.relatics)}
                            />
                            <Tab
                                className={classes.tabItem}
                                label="Asite sync logs"
                                value={'asite'}
                                component={Link}
                                to={routes['asite']}
                                onClick={() => changeTab(ESyncLogsTabs.asite)}
                            />
                            <Tab
                                className={classes.tabItem}
                                label="configuration"
                                value={'configuration'}
                                component={Link}
                                to={routes['configuration']}
                                onClick={() => changeTab(ESyncLogsTabs.configuration)}
                            />
                        </Tabs>
                    </Paper>
                </Grid>
                <Grid item md={12}>
                    <Paper className={classesPaper.defaultPaper}>
                        <Switch>
                            <SabsPrivateRoute
                                path={routes['relatics']}
                                redirectTo={accessDeniedPath}
                                authorize={isPageAuthorized}
                            >
                                <RelaticsSyncLogs connection={connection} />
                            </SabsPrivateRoute>
                            <SabsPrivateRoute
                                path={routes['asite']}
                                redirectTo={accessDeniedPath}
                                authorize={isPageAuthorized}
                            >
                                <AsiteSyncLogs />
                            </SabsPrivateRoute>
                            <SabsPrivateRoute
                                path={routes['configuration']}
                                redirectTo={accessDeniedPath}
                                authorize={isPageAuthorized}
                            >
                                <ConfigurationFolder />
                            </SabsPrivateRoute>
                        </Switch>
                    </Paper>
                </Grid> 
                
            </Grid>
        }
        {!isLoaded && <LoadingPanel />}
        </Container>
    );
};

export default Menu;
